import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../../mutation-types';
import CrmAutomationsAPI from '../../../api/crm/automations';

export const state = {
    records: [],
    uiFlags: {
        isFetching: false,
        isCreating: false,
        isUpdating: false,
        isDeleting: false,
    },
};

export const getters = {
    getUIFlags(_state) {
        return _state.uiFlags;
    },
    getAutomations(_state) {
        return _state.records;
    },
    getAutomationById: _state => id => {
        return _state.records.find(r => r.id === Number(id));
    },
};

export const actions = {
    get: async ({ commit }) => {
        commit(types.SET_CRM_AUTOMATIONS_UI_FLAG, { isFetching: true });
        try {
            const response = await CrmAutomationsAPI.get();
            commit(types.SET_CRM_AUTOMATIONS, response.data);
        } catch (error) {
            // Ignore error
        } finally {
            commit(types.SET_CRM_AUTOMATIONS_UI_FLAG, { isFetching: false });
        }
    },
    create: async ({ commit }, automationObj) => {
        commit(types.SET_CRM_AUTOMATIONS_UI_FLAG, { isCreating: true });
        try {
            const response = await CrmAutomationsAPI.create(automationObj);
            commit(types.ADD_CRM_AUTOMATION, response.data);
            return response.data;
        } catch (error) {
            throw new Error(error);
        } finally {
            commit(types.SET_CRM_AUTOMATIONS_UI_FLAG, { isCreating: false });
        }
    },
    update: async ({ commit }, { id, ...updateObj }) => {
        commit(types.SET_CRM_AUTOMATIONS_UI_FLAG, { isUpdating: true });
        try {
            const response = await CrmAutomationsAPI.update(id, updateObj);
            commit(types.EDIT_CRM_AUTOMATION, response.data);
        } catch (error) {
            throw new Error(error);
        } finally {
            commit(types.SET_CRM_AUTOMATIONS_UI_FLAG, { isUpdating: false });
        }
    },
    delete: async ({ commit }, id) => {
        commit(types.SET_CRM_AUTOMATIONS_UI_FLAG, { isDeleting: true });
        try {
            await CrmAutomationsAPI.delete(id);
            commit(types.DELETE_CRM_AUTOMATION, id);
        } catch (error) {
            throw new Error(error);
        } finally {
            commit(types.SET_CRM_AUTOMATIONS_UI_FLAG, { isDeleting: false });
        }
    },
};

export const mutations = {
    [types.SET_CRM_AUTOMATIONS_UI_FLAG](_state, data) {
        _state.uiFlags = { ..._state.uiFlags, ...data };
    },
    [types.SET_CRM_AUTOMATIONS]: MutationHelpers.set,
    [types.ADD_CRM_AUTOMATION]: MutationHelpers.create,
    [types.EDIT_CRM_AUTOMATION]: MutationHelpers.update,
    [types.DELETE_CRM_AUTOMATION]: MutationHelpers.destroy,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
